import React from 'react';
import { Alert } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from 'routing/Routes';

import styles from './LicenseNotification.css';

const LicenseViolationNotification = React.createClass({
  render() {
    return (
      <div className={`container-fluid ${styles.licenseNotification}`}>
        <Alert bsStyle="danger">
          <h4 style={{ marginBottom: 5 }}><strong>Graylog Enterprise License Violation</strong></h4>
          <p>
              At least one term of your Graylog Enterprise license has been violated.
              Go to the <LinkContainer to={Routes.pluginRoute('SYSTEM_LICENSES')}><a>License page</a></LinkContainer> for
              more information or contact your Graylog account manager.
          </p>
        </Alert>
      </div>
    );
  },
});

export default LicenseViolationNotification;



// WEBPACK FOOTER //
// ./src/web/notifications/LicenseViolationNotification.jsx